import { featureFlags } from './featureFlags';

export const DATE_FORMAT = 'dd-MMM-yyyy';
export const API_DATE_FORMAT = 'yyyy-MM-dd';
export const OPERATION_ROLE = featureFlags.UCT ? 'Logistic' : 'Operation';
